import { withI18nPlaceholders } from '@change-corgi/core-react/i18n';

import I18N_PLACEHOLDERS from '#config/i18n/placeholders/uk-surging-petition-toast/uk-surging-petition-toast.yml';

import { UkSurgingPetitionToast as UkSurgingPetitionToastComponent } from './containers/UkSurgingPetitionToast';

export const UkSurgingPetitionToast = withI18nPlaceholders(I18N_PLACEHOLDERS, UkSurgingPetitionToastComponent);
